<template>
  <div class="relative group mt-30">
    <div class="relative">
      <NuxtLink
        v-for="pin in instagramProducts.pins"
        :key="`pin-spot-${pin.product.id}`"
        :to="`/${pin.product.uri}`"
        class="p-10 ring-[3px] ring-white rounded-full absolute -translate-x-1/2 -translate-y-1/2 block"
        :style="`left: ${pin.x}%; top: ${pin.y}%`"
      >
        <div class="w-15 h-15 rounded-full bg-white" />
      </NuxtLink>
      <img
        v-if="instagramProducts.canvas?.url"
        :src="instagramProducts.canvas?.url"
        class="w-full"
        :alt="`Producten: ${altText}`"
      >
    </div>
    <NuxtLink
      v-if="instagramProducts.pins.length"
      :to="`/${instagramProducts.pins[0].product?.uri}`"
      class="flex mt-1"
    >
      <div class="bg-primary-100 w-[130px]">
        <img
          v-if="instagramProducts.pins[0].product?.productImages?.length"
          :src="instagramProducts.pins[0].product?.productImages[0].url"
          class="mix-blend-darken"
          :alt="instagramProducts.pins[0].product?.title"
        >
      </div>

      <div class="flex flex-1 p-20 ml-1 text-base items-center text-primary-700 bg-primary-100 group-hover:underline transition">
        <p>
          <b>{{ instagramProducts.pins[0].product?.title }}</b><br>
          <product-price :product="instagramProducts.pins[0].product" />
        </p>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
import { computed } from '#imports';

// Props
const props = defineProps({
  instagramProducts: {
    type: Object,
    required: true,
  },
});

// Alt text for product image
const altText = computed(() => props.instagramProducts.pins.map((entry) => entry.product.title).join(', '));
</script>
